import { siteConfig, telHref } from "@/config/siteConfig";
import { trackEvent } from "@/lib/analytics";
import { CallButton, WhatsAppButton } from "@/components/CtaButtons";
import { Reveal } from "@/components/Reveal";

export const ContactCta = () => (
  <section id="iletisim" data-testid="contact-cta-section" className="relative scroll-mt-20 overflow-hidden bg-ink-950 py-20 md:py-28">
    <img
      src="/img/salihli-oto-cekici-hero-desktop.webp"
      alt=""
      aria-hidden="true"
      loading="lazy"
      decoding="async"
      className="absolute inset-0 h-full w-full object-cover opacity-15"
    />
    <div className="absolute inset-0 bg-gradient-to-b from-ink-950/70 via-ink-950/85 to-ink-950" aria-hidden="true" />
    <div className="relative mx-auto max-w-4xl px-5 text-center">
      <Reveal>
        <p className="font-display text-xs font-bold uppercase tracking-[0.28em] text-white/60">İletişim</p>
        <h2 className="mt-4 font-display text-4xl font-black uppercase leading-[1.02] tracking-tight text-white sm:text-5xl" data-testid="contact-cta-title">
          Yolda mı Kaldınız?
          <span className="mt-2 block text-brand">Bize Ulaşın, Hızla Yola Çıkalım.</span>
        </h2>
        <a
          href={telHref}
          data-testid="cta-phone-number"
          onClick={() => trackEvent("phone_click", "contact")}
          className="mt-6 inline-block font-display text-3xl font-extrabold tracking-tight text-white transition-colors hover:text-brand sm:text-4xl"
        >
          {siteConfig.phone.display}
        </a>
        <div className="mt-9 flex flex-col justify-center gap-3.5 sm:flex-row">
          <CallButton location="cta_bottom" sub={siteConfig.phone.display} className="px-8 py-4 text-lg" testid="cta-call-button" />
          <WhatsAppButton location="cta_bottom" className="px-8 py-4 text-base" testid="cta-whatsapp-button" />
        </div>
      </Reveal>
    </div>
  </section>
);
